var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-guidelines-header"},[_c('CofocusLogo',{staticStyle:{"transform":"scale(1.5)"}}),_c('div',{staticClass:"mini-guidelines-text"},[_vm._v("Session Guidelines")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }